<ng-container *ngIf="control.hasError('required')">
  {{ 'AuthErrors.EnterValue' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('email')">
  {{ 'AuthErrors.InvalidEmail' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('emailExists')">
  {{ 'AuthErrors.EmailExists' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('minlength')">
  {{ 'AuthErrors.Password8Characters' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('validatePasswordStrength')">
  {{ 'AuthErrors.PasswordNotStrong' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('validatePostalCode')">
  {{ 'AuthErrors.PostalCodeInvalid' | translate }}
</ng-container>
<ng-container *ngIf="control.hasError('notEqual')">
  {{ 'AuthErrors.PasswordsDontMatch' | translate }}
</ng-container>
<ng-container *ngIf="control.getError('dateSandwich') as error">
  {{ 'AdminErrors.Date.' + error.control | translate }}
</ng-container>
<ng-container *ngIf="control.getError('oneChecked') as error">
  {{ 'AdminErrors.OneChecked' | translate }}
</ng-container>
<ng-container *ngIf="control.getError('max') as error">
  {{ 'AdminErrors.Max' | translate : control.getError('max') }}
</ng-container>
<ng-container *ngIf="control.getError('min') as error">
  {{ 'AdminErrors.Min' | translate : control.getError('min') }}
</ng-container>
<ng-container *ngIf="control.getError('positiveWholeNumber') as error">
  {{ 'AdminErrors.PositiveWholeNumber' | translate : control.getError('positiveWholeNumber') }}
</ng-container>

<!-- <pre>{{ control.errors | json }}</pre> -->
<!-- <pre>{{ control.getError('maxlength') | json }}</pre> -->
